/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface UserControllerUpdateDeviceInfoBodyRequest {
  /** FCM 토큰 (필수). 이 값이 이후 푸시 발송 대상 기기를 결정한다. 없으면 2002 로 거절한다. */
  fcmToken?: string;
  deviceInfo: {
    /** 운영체제 (예: WINDOW, MAC, Web) */
    OS: string;
    /** 운영체제 상세 (예: Windows_NT 10.0.19045) */
    osType: string;
    /** OS 버전 */
    version?: string;
    /** 기기 이름 */
    deviceName?: string;
    /** 앱 버전 */
    appVersion?: string;
  };
}

export interface UserControllerUpdateDeviceInfoResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiElUpdateDeviceinfoHandlerBodyRequest {
  deviceInfo: {
    OS: string;
    osType: string;
    version?: string;
    deviceName?: string;
    appVersion?: string;
  };
  fcmToken: string;
}

export interface ApiElUpdateDeviceinfoHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface UserMPhoneCodeHandlerBodyRequest {
  countryID?: string;
  phone: string;
}

export interface UserMPhoneCodeHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 아이디 / 비밀번호 찾기를 수행한 userID */
    userID?: string;
    /** 휴대폰번호를 단방향 암호화한 휴대폰ID */
    phoneID: string;
    /**
     * 인증코드를 통한 인증 여부
     * @format date
     */
    createdAt: string;
    /**
     * 수정일
     * @format date
     */
    updatedAt: string;
    /**
     * 인증코드 만료일
     * @format date
     */
    expiredAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface UserMPhoneUpdateHandlerBodyRequest {
  phoneID: string;
  countryID?: string;
  phone: string;
}

export interface UserMPhoneUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 프로필 이미지로 사용될 파일의 ID */
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths?: string[] | null;
          aws?: {
            ETag?: string;
            Location?: string;
            Key?: string;
            key?: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize?: string;
            fileName?: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      doctorID: string;
      hospitalID?: {
        /** MongoDB Identifier */
        _id: string;
        shortName: string;
        address?: string;
        introduction: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser?: string;
        homepageURL?: string;
        phone?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription: string;
        nurseID?: string;
        isSecondEdition?: boolean;
        usingVideoContent?: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent?: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        countryIds?: string[];
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt?: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    token?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface UserMUpdateHandlerBodyRequest {
  userID: string;
  name: string;
}

export interface UserMUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      doctorID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      hospitalID?: {
        _id: string;
        name: string;
        shortName: string;
        businessName?: string;
        /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
        msoHospitalName?: string;
        address?: string;
        addressInfo?: Record<string, string>;
        department: string[];
        introduction?: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser: string;
        homepageURL?: string;
        phone?: string;
        smsPhone?: string;
        isSMSSendingBlocked?: boolean;
        /** @format date */
        smsSendingBlockedAt?: string;
        /** @format date */
        smsSendingUnblockedAt?: string;
        smsSendingBlockedBy?: string;
        smsSendingBlockReason?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        initialChat?: string;
        initialChats: {
          chatType?: number;
          content?: string;
          fileIDs?: any[] | null;
        }[];
        defaultFlag: string;
        therapyList: string[];
        isBasicMessage?: boolean;
        smsMessage?: string;
        smsMessageA?: string;
        smsMessageB?: string;
        smsChatMessage?: string;
        smsChatMessageA?: string;
        smsChatMessageB?: string;
        usingBasicMessage?: boolean;
        smsBasicMessage?: string;
        smsBasicMessageEdit?: string;
        usingReservationMessage?: boolean;
        smsReservation?: string;
        smsReservationEdit?: string;
        usingResendMessage?: boolean;
        smsResendMessage?: string;
        smsResendMessageEdit?: string;
        usingAutoReservedSMS?: boolean;
        autoReservedSMSMessage?: string;
        autoReservedSMSDelayDay?: number;
        autoReservedSMSHour?: number;
        chatReservationGuide?: string;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription?: string;
        smsLogoImage?:
          | string
          | {
              _id?: string;
              paths?: string[] | null;
              aws?: any[] | null;
            };
        isUsingLogo?: boolean;
        nurseID: string;
        nurseIDs: string[];
        hospitalType: "single" | "multi";
        usingRegistUser?: boolean;
        isClosed: boolean;
        serviceSetting: string;
        hasActiveSheet?: boolean;
        isSecondEdition?: boolean;
        usingVideoContent: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        isTest?: boolean;
        /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
        locale?: string;
        /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
        timezone?: string;
        unsubscriptionPhone?: string;
        unsubscriptionNumber?: string;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    token?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface UserMSuspendAllHandlerBodyRequest {
  userID: string;
  closeReason: string[];
}

export interface UserMSuspendAllHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    isSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiUserMFindOneParams {
  /** (required) 병원ID */
  userID?: string;
}

export type ApiUserMFindOneData = any;

export type UserControllerUpdateDeviceInfoData = UserControllerUpdateDeviceInfoResponse;

export type ApiElUpdateDeviceinfoHandlerData = ApiElUpdateDeviceinfoHandlerResponse;

export type UserMPhoneCodeHandlerData = UserMPhoneCodeHandlerResponse;

export type UserMPhoneUpdateHandlerData = UserMPhoneUpdateHandlerResponse;

export type UserMUpdateHandlerData = UserMUpdateHandlerResponse;

export type UserMSuspendAllHandlerData = UserMSuspendAllHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-User
     * @name ApiUserMFindOne
     * @summary SaaS 모바일 유저 정보 조회
     * @request GET:/v3/api/user/m/find/one
     * @secure
     * @response `200` `ApiUserMFindOneData` \{User\} 객체 조회
     */
    apiUserMFindOne: (query: ApiUserMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiUserMFindOneData, any>({
        path: `/v3/api/user/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 직원 계정에 FCM 기기 토큰과 기기 정보를 등록한다. 등록 결과가 이후 그 직원에게 가는 푸시의 수신 대상을 결정한다. 같은 토큰을 들고 있던 다른 계정에서는 토큰을 회수한다(한 PC 를 번갈아 쓰는 경우). SaaS 병원은 토큰을 1개만 유지하고, 비-SaaS 병원과 서비스 매니저 계정은 최대 10개까지 누적한다. 레거시 /v3/api/user/el/update/deviceinfo 를 대체한다.
     *
     * @tags V3-User
     * @name UserControllerUpdateDeviceInfo
     * @summary FCM 토큰 정보 업데이트
     * @request PATCH:/v3/api/user/update/deviceinfo
     * @secure
     * @response `200` `UserControllerUpdateDeviceInfoData` success
     */
    userControllerUpdateDeviceInfo: (data: UserControllerUpdateDeviceInfoBodyRequest, params: RequestParams = {}) =>
      this.request<UserControllerUpdateDeviceInfoData, any>({
        path: `/v3/api/user/update/deviceinfo`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description FCM 토큰 정보 업데이트 (deprecated — /v3/api/user/update/deviceinfo 사용)
     *
     * @tags V3-User
     * @name ApiElUpdateDeviceinfoHandler
     * @summary FCM 토큰 정보 업데이트: ts
     * @request PATCH:/v3/api/user/el/update/deviceinfo
     * @secure
     * @response `200` `ApiElUpdateDeviceinfoHandlerData` success
     */
    apiElUpdateDeviceinfoHandler: (data: ApiElUpdateDeviceinfoHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ApiElUpdateDeviceinfoHandlerData, any>({
        path: `/v3/api/user/el/update/deviceinfo`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 전화번호 변경을 위한 코드 발송 요청
     *
     * @tags V3-User
     * @name UserMPhoneCodeHandler
     * @summary 전화번호 변경을 위한 코드 발송 요청: ts
     * @request POST:/v3/api/user/m/phone/code
     * @secure
     * @response `200` `UserMPhoneCodeHandlerData` success
     */
    userMPhoneCodeHandler: (data: UserMPhoneCodeHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<UserMPhoneCodeHandlerData, any>({
        path: `/v3/api/user/m/phone/code`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 인증된 번호로 전화번호 변경
     *
     * @tags V3-User
     * @name UserMPhoneUpdateHandler
     * @summary 인증된 번호로 전화번호 변경: ts
     * @request PATCH:/v3/api/user/m/phone/update
     * @secure
     * @response `200` `UserMPhoneUpdateHandlerData` success
     */
    userMPhoneUpdateHandler: (data: UserMPhoneUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<UserMPhoneUpdateHandlerData, any>({
        path: `/v3/api/user/m/phone/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 유저 정보 수정 - 이름만 변경 가능
     *
     * @tags V3-User
     * @name UserMUpdateHandler
     * @summary 유저 정보 수정 - 이름만 변경 가능: ts
     * @request PATCH:/v3/api/user/m/update
     * @secure
     * @response `200` `UserMUpdateHandlerData` success
     */
    userMUpdateHandler: (data: UserMUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<UserMUpdateHandlerData, any>({
        path: `/v3/api/user/m/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 유저 전체 서비스 종료
     *
     * @tags V3-User
     * @name UserMSuspendAllHandler
     * @summary 유저 전체 서비스 종료: ts
     * @request POST:/v3/api/user/m/suspend/all
     * @secure
     * @response `200` `UserMSuspendAllHandlerData` success
     */
    userMSuspendAllHandler: (data: UserMSuspendAllHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<UserMSuspendAllHandlerData, any>({
        path: `/v3/api/user/m/suspend/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
